module.exports = __webpack_public_path__ + "img/0Q3A5801_L_Foamcore_MockedUp.3c4277ba.jpg";